import { MagicPen2, CommandIcon, PenTool, ClipboardTick } from "assets/website";

interface FeatureItem {
  icon: React.FC<React.SVGProps<SVGSVGElement>>;
  title: string;
  description: string;
  iconBgColor: string;
}

const features: FeatureItem[] = [
  {
    icon: MagicPen2,
    title: "Consistent Performance",
    description:
      "Standardize evaluation tracks, reviews, and continuous development plans, and align real output to compensation with total transparency.",
    iconBgColor: "bg-[#FEEED4]",
  },
  {
    icon: CommandIcon,
    title: "Leadership Visibility",
    description:
      "Unlock immediate visual access into division targets, operational blockages, and individual execution speed in one unified system view.",
    iconBgColor: "bg-[#D2F2FA]",
  },
  {
    icon: PenTool,
    title: "Stronger Accountability",
    description:
      "Eliminate silent bystander delays by equipping every single contributor with clear, signed operating statements and ownership matrices.",
    iconBgColor: "bg-[#FFE1EB]",
  },
  {
    icon: ClipboardTick,
    title: "Better Execution",
    description:
      "Turn broad business ambitions into measurable key milestones and daily actionable tasks without losing organizational momentum.",
    iconBgColor: "bg-[#E5E5FF]",
  },
];

const WhyChooseSuite = () => {
  return (
    <section className="py-16 md:py-24 lg:px-6 px-4">
      <div className="container mx-auto sm:px-4 !px-0">
        {/* Section Header */}
        <div className="text-center max-w-3xl mx-auto mb-12 md:mb-16">
          <h2
            data-aos="fade-up"
            className="text-2xl md:text-4xl lg:text-5xl font-display font-bold text-[#050B17] mb-4"
          >
            Why Teams Choose The Suite
          </h2>
          <p
            data-aos="fade-up"
            data-aos-delay="100"
            className="text-base md:text-lg lg:text-xl text-[#475467]"
          >
            Most hiring tools tell you who looks good. Precision shows you who
            will actually execute, grow, and stay aligned with your team's
            rhythm.
          </p>
        </div>

        {/* Features Grid */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6">
          {features.map((feature, index) => (
            <div
              key={feature.title}
              data-aos="fade-up"
              data-aos-delay={100 + index * 100}
              className="bg-[#F9FAFB] pt-8 pr-[18px] pb-8 pl-[18px] rounded-[15px] shadow-[0px_1px_3px_0px_#0000001A]  transition-all duration-300"
            >
              <div
                className={`w-12 h-12 ${feature.iconBgColor} rounded-xl flex items-center justify-center mb-14`}
              >
                <feature.icon className="w-6 h-6 text-neutral-700" />
              </div>
              <h3 className="lg:text-xl text-lg font-semibold text-neutral-900 mb-3">
                {feature.title}
              </h3>
              <p className="text-base text-[#475467] leading-relaxed">
                {feature.description}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export { WhyChooseSuite };
